import React from "react";

/**
 * This component is for embedding entire forms built in HubSpot.
 */

interface Props {
    formId: string;
    portalId: string;
}

function HubSpotFormEmbed({ formId, portalId }: Props) {
    const id = `hubspotForm-${formId}`;

    function createForm() {
        if (window.hbspt) {
            window.hbspt.forms.create({
                portalId: portalId,
                formId: formId,
                target: "#" + id
            });
        } else {
            console.error("hbspt not defined");
        }
    }

    React.useEffect(() => {
        if (!window.hbspt) {
            const script = document.createElement("script");
            script.src = "https://js.hsforms.net/forms/v2.js";
            document.body.appendChild(script);
            script.addEventListener("load", createForm);
        } else {
            createForm();
        }
    }, []);

    return <div id={id}></div>;
}

export default HubSpotFormEmbed;
